import React, { useState, useCallback } from 'react';
import { AlertTriangle, Check } from 'lucide-react';
import CarouselShortsSection from './CarouselShortsSection.jsx';
import CoachingProgramsSection from './CoachingProgramsSection.jsx';
import FreeClassesSection from './FreeClassesSection.jsx';
import PromotionalBannersSection from './PromotionalBannersSection.jsx';
import UpcomingCoursesSection from './UpcomingCoursesSection.jsx';
import ScholarshipSection from './ScholarshipSection.jsx';
import KeysSection from './KeysSection.jsx';

// Main AppHome Component
const AppHome = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = 'success') => {
    setNotification({ message, type });
    const timer = setTimeout(() => setNotification(null), 3000);
    
    // Cleanup function to prevent memory leaks
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-slate-900">AppHome</h1>
      </div>

      {/* Notification */}
      {notification && (
        <div className={`mb-4 p-3 rounded-md ${
          notification.type === 'success' ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
        }`}>
          <div className="flex items-center">
            {notification.type === 'success' ? <Check size={16} className="mr-2" /> : <AlertTriangle size={16} className="mr-2" />}
            <p>{notification.message}</p>
          </div>
        </div>
      )}

      {/* Content Sections */}
      <CoachingProgramsSection showNotification={showNotification} />
      <UpcomingCoursesSection showNotification={showNotification} />
      <ScholarshipSection showNotification={showNotification} />
      <CarouselShortsSection showNotification={showNotification} />
      <FreeClassesSection showNotification={showNotification} />
      <PromotionalBannersSection showNotification={showNotification} />
      <KeysSection showNotification={showNotification} />
    </div>
  );
};

export default AppHome;